import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LOGIN_REQUEST_MORE_DETAILS } from '../../../../../../manager/http-constants';
import { TOAST } from '../../../../shared/constant/primeng-constants';
import { MESSAGE_CODE } from '../../../../shared/constant/message-constant';
import { ActivatedRoute } from '@angular/router';
import { API_RESPONSE } from 'src/app/shared/constant/api-constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { MessageData, ToastMessageData } from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';

@Component({
  selector: 'app-confirm-request-more-details-dialog',
  templateUrl: './confirm-request-more-details-dialog.component.html',
  styleUrls: ['./confirm-request-more-details-dialog.component.scss']
})
export class ConfirmRequestMoreDetailsDialogComponent implements OnInit {

  @Output() returnValue = new EventEmitter<void>();

  isShow = false;
  organizationName = '';
  memberId: string | number = 0;
  userId: string | number = 0;
  postId = 0;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData
  ) { }

  ngOnInit(): void {
  }

  /**
   * open dialog
   */
  openDialog(organizationName: string, memberId: number, userId: number, postId: number): void {
    this.organizationName = organizationName;
    this.memberId = memberId;
    this.userId = userId;
    this.postId = postId;
    this.isShow = true;
  }

  /**
   * confirm quoting agenda
   */
  confirm(): void {
    this.returnValue.emit();
    this.isShow = false;
    this.requestMoreDetails();
  }

  /**
   * close dialog without quoting
   */
  closeDialog(): void {
    this.isShow = false;
  }

  requestMoreDetails(): void {
    const moreDetailsForm = {
      post_id: this.postId,
      member_id: this.memberId,
      user_id: this.userId,
    };

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOGIN_REQUEST_MORE_DETAILS);

    // 会員申請登録を実施
    this.dbOperationService
      .getNoTemplateData(LOGIN_REQUEST_MORE_DETAILS, moreDetailsForm, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOGIN_REQUEST_MORE_DETAILS);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.SUCCESS,
              summary: '話を聞きたい',
              detail: '通知をしました',
            })
          );
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
        }
      });
  }

}
